import type { ChatConfig, SubmitQuestionResponse } from '@/types/chat';

export class ChatApiError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'ChatApiError';
    this.status = status;
  }
}

interface SubmitQuestionOptions {
  config: ChatConfig;
  question: string;
  authToken?: string | null;
}

export async function submitQuestion(options: SubmitQuestionOptions): Promise<SubmitQuestionResponse> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (options.authToken) {
    headers.Authorization = `Bearer ${options.authToken}`;
  }

  const response = await fetch(options.config.apiUrl, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      session_id: options.config.sessionId,
      question: options.question,
    }),
  });

  if (!response.ok) {
    throw new ChatApiError(response.statusText || 'Request failed', response.status);
  }

  return response.json() as Promise<SubmitQuestionResponse>;
}
